<header class="header" [class]="isBackEventListened ? 'header--back-btn' : ''">
  @if (isBackEventListened) {
    <button matIconButton color="primary" [disabled]="isBackDisabled" (click)="back()">
      <mat-icon [fontIcon]="backIcon" />
    </button>
  }
  @if (icon) {
    <mat-icon class="header_icon" [fontIcon]="icon" />
  }
  <!-- Display a simple string title or an Angular template -->
  @if (title && !template) {
    <h1
      [class]="isBackEventListened ? 'header_title--small' : 'header_title'"
      [matTooltip]="title"
      ubiShowIfTruncated>
      {{ title }}
    </h1>
  } @else if (template && !title) {
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  }
  <div class="header_actions">
    <!-- Pass actions in slot -->
    <ng-content></ng-content>
  </div>
</header>
